import toEN from './toEn';
export const checkMobilePhone = (number) => {
  number = number + '';
  number = toEN(number);
  const p1 = /^09(\d{9})/;
  const p2 = /^\+989(\d{9})/;
  const p3 = /^989(\d{9})/;
  const p4 = /^9(\d{9})/;
  const p5 = /^\+9809(\d{9})/;
  const p6 = /^9809(\d{9})/;

  if (!!p1.exec(number)) {
    return '+989' + p1.exec(number)[1];
  }
  if (!!p2.exec(number)) {
    return '+989' + p2.exec(number)[1];
  }
  if (!!p3.exec(number)) {
    return '+989' + p3.exec(number)[1];
  }
  if (!!p4.exec(number)) {
    return '+989' + p4.exec(number)[1];
  }
  if (!!p5.exec(number)) {
    return '+989' + p5.exec(number)[1];
  }
  if (!!p6.exec(number)) {
    return '+989' + p6.exec(number)[1];
  }
  return false;
};
export default checkMobilePhone;
